import dynamic from 'next/dynamic'

export const VodPrograms = dynamic(() => import('./VodPrograms/VodPrograms'), {
  ssr: true,
})
export const Vod = dynamic(() => import('./Vod/Vod'), { ssr: true })
export const VodLeft = dynamic(() => import('./VodLeft/VodLeft'), { ssr: true })
export const VodGenresCarousel = dynamic(
  () => import('./VodGenresCarousel/VodGenresCarousel'),
  { ssr: true }
)
export const VodEpisodes = dynamic(() => import('./VodEpisodes/VodEpisodes'), {
  ssr: true,
})
export const Opinions = dynamic(() => import('./Opinions/Opinions'), {
  ssr: true,
})
export const VodPlaylist = dynamic(() => import('./VodPlaylist/VodPlaylist'), {
  ssr: true,
})
export const MidBoxMobile = dynamic(
  () => import('./GridBlocks/MidBoxMobile/MidBoxMobile'),
  { ssr: false }
)
export const Separator = dynamic(() => import('./Separator/Separator'))
export const Pager = dynamic(() => import('./Pager/Pager'))
export const TimeLineBlock = dynamic(() => import('./GridBlocks/TimeLineBlock'))
export const AllShows = dynamic(() => import('./AllShows/AllShows'))
export const Reels = dynamic(() => import('./GridBlocks/Reels/Reels'))
export const Stories = dynamic(() => import('./GridBlocks/Stories/Stories'))
export const WarTimeLine = dynamic(() => import('./WarTimeLine/WarTimeLine'), {
  ssr: true,
})
export const Hero = dynamic(() => import('./Hero/Hero'), { ssr: true })
export const CategoryOpener = dynamic(
  () => import('./CategoryOpener/CategoryOpener'),
  { ssr: true }
)

export const TermHeadBlock = dynamic(
  () => import('../components/TermHeadBlock/TermHeadBlock'),
  { ssr: true }
)

export const GridVideo = dynamic(
  () => import('../components/GridVideo/GridVideo'),
  {
    ssr: true,
  }
)
export const ImageCounter = dynamic(
  () => import('../components/ImageCounter/ImageCounter'),
  { ssr: true }
)
export const MainStandard = dynamic(
  () => import('../components/Main/MainStandard'),
  { ssr: true }
)
export const MainTextOver = dynamic(
  () => import('../components/Main/MainTextOver'),
  { ssr: true }
)
export const Advertisers = dynamic(
  () => import('../components/Advertisers/Advertisers')
)
